import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_BUS004_Request,
  IAPI_BUS004_Response,
  IAPI_COM005_Request,
  IAPI_COM005_Response,
  IAPI_COM009_Request,
  IAPI_COM009_Response,
  IAPI_CON008_Request,
  IAPI_CON008_Response,
  IAPI_CON015_Request,
  IAPI_CON015_Response,
  IAPI_CON030_Request,
  IAPI_CON030_Response,
  IAPI_CON031_Request,
  IAPI_CON031_Response,
} from "../../../type/apiType";
import {
  IAPI_CON032_Request,
  IAPI_CON032_Response,
} from "../../../type/apiType/IAPI_CON032";

// 退職手当共済契約解除参照
// API仕様書_契約者
const httpIAPI_CON008 = async (
  param: IAPI_CON008_Request
): Promise<IAPI_CON008_Response> => {
  let res = await http.post(ApiUrl.API_CON008, {
    ...param,
  });

  return res.data;
};

// 退職手当共済契約解除更新API
// API仕様書_施設
const httpIAPI_CON015 = async (
  param: IAPI_CON015_Request
): Promise<IAPI_CON015_Response> => {
  let res = await http.post(ApiUrl.API_CON015, {
    ...param,
  });
  return res.data;
};

// 契約解除（加入者全員の同意）同意書帳票要求更新API
// API仕様書_契約者
const httpIAPI_CON032 = async (
  param: IAPI_CON032_Request
): Promise<IAPI_CON032_Response> => {
  let res = await http.post(ApiUrl.API_CON032, {
    ...param,
  });
  return res.data;
};

// 帳票作成状況取得API
const httpAPI_COM009 = async (
  param: IAPI_COM009_Request
): Promise<IAPI_COM009_Response> => {
  let res = await http.post(ApiUrl.API_COM009, {
    ...param,
  });

  return res.data;
};

// 帳票ダウンロード(汎用)
const httpAPI_COM005 = async (
  param: IAPI_COM005_Request
): Promise<IAPI_COM005_Response> => {
  let res = await http.post(ApiUrl.API_COM005, {
    ...param,
  });

  return res.data;
};

//退職手当金請求者有無チェックAPI
const httpAPI_BUS004 = async (
  param: IAPI_BUS004_Request
): Promise<IAPI_BUS004_Response> => {
  let res = await http.post(ApiUrl.API_BUS004, {
    ...param,
  });

  return res.data;
};

// 日々更新法人職員系の退職年月日削除職員確認API
const httpIAPI_CON031 = async (
  param: IAPI_CON031_Request
): Promise<IAPI_CON031_Response> => {
  let res = await http.post(ApiUrl.API_CON031, {
    ...param,
  });

  return res.data;
};

// 日々更新法人職員系の退職年月日削除API
const httpIAPI_CON030 = async (
  param: IAPI_CON030_Request
): Promise<IAPI_CON030_Response> => {
  const res = await http.post(ApiUrl.API_CON030, {
    ...param,
  });

  return res.data;
};

export {
  httpIAPI_CON008,
  httpIAPI_CON015,
  httpIAPI_CON032,
  httpAPI_COM009,
  httpAPI_COM005,
  httpAPI_BUS004,
  httpIAPI_CON031,
  httpIAPI_CON030,
};
